module.exports = __webpack_public_path__ + "static/ShitijMalhotra-19d08a2b012a232a730850e516368495.jpg";